import React, { Component } from 'react';
import Slider from 'react-slick'; // Make sure you have installed react-slick
import NewStoryCard from '../../desktop/NewStoryCard'; // Assuming this renders the viral video item
import NewStoryCardMobile from '../../mobile/NewStoryCard'; // Assuming this renders the viral video item

import InViewObserver from '../../../components/InViewObserver/InViewObserver'; // Tracks when the slider is in view
import Link from '../../../components/Link/Link';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import SubsectionList from '../../mobile/SubsectionList/SubsectionList';
import Morebtn from '../../../components_v2/mobile/Morebtn';
import s from './ProductSliderWrapper.scss';
import { formatPrice } from '../../../utils/common';

class ProductSliderWrapper extends Component {
  render() {
    const { title, ga4Type, path, items, isWapView } = this.props;

    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 5, // Number of slides visible
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1510, // For medium desktop
          settings: {
            slidesToShow: 4, // Number of slides visible
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      items &&
      Array.isArray(items) &&
      items.length > 0 && (
        <div className={`${s.productWrapper} noPaddingTitle`}>
          <div className={s.title}>
            <SubsectionList headingname={title} className={s.head} />

            {!isWapView &&
              path && (
                <Link
                  to={path}
                  target="_blank"
                  className={s.viewAll}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: ga4Type,
                      category: 'view_more_cta',
                      label: 'view_more',
                    },
                  ]}
                >
                  View All
                </Link>
              )}
          </div>
          <InViewObserver
            inViewCallback={() => {
              if (ga4Type) {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: ga4Type,
                });
              }
            }}
          >
            {isWapView && (
              <>
                <div className={s.vScroll}>
                  {items &&
                    Array.isArray(items) &&
                    items.length > 0 &&
                    items.map((item, index) => (
                      <>
                        <div className={s.listItem}>
                          <NewStoryCardMobile
                            title={item.productName}
                            msid={item.imageId}
                            imagesize={item?.imagesize}
                            cardType="card_19"
                            wu={`${
                              item.productUrl
                            }?utm_source=TOI&utm_medium=referral`}
                            syn={`₹${formatPrice(item.price)}`} //Price
                            sectionName="View Specs"
                            gaIndex={index + 1}
                            ga4Type="latest_mobiles_widget"
                            // shouldNotlazyloadImage={shouldNotlazyloadImage}
                            ga4Label={item.productName}
                          />
                        </div>
                      </>
                    ))}
                </div>
                <Morebtn
                  moreLink={path}
                  absoluteMoreText="More Mobiles"
                  ga4Type={ga4Type}
                  ga4Category="view_more_cta"
                  gaLabel="view_more"
                />
              </>
            )}
            {!isWapView && (
              <div className="slick_UI">
                <Slider {...settings}>
                  {items &&
                    items.map((item, index) => (
                      <NewStoryCard
                        title={item.productName}
                        msid={item.imageId}
                        imagesize={item?.imagesize}
                        syn={`₹${formatPrice(item.price)}`}
                        sectionName="View Specs"
                        wu={`${
                          item.productUrl
                        }?utm_source=TOI&utm_medium=referral`}
                        target="_blank"
                        cardType="card_25"
                        gaIndex={index + 1}
                        ga4Type="latest_mobiles_widget"
                        // shouldNotlazyloadImage={shouldNotlazyloadImage}
                        ga4Label={item.productName}
                      />
                    ))}
                </Slider>
              </div>
            )}
          </InViewObserver>
        </div>
      )
    );
  }
}

export default ProductSliderWrapper;
